// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Text Component */
:host([hidden]) {
  display: none !important;
}

:host([overflow=ellipsis]) {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
}

:host([tooltip]) .ids-text:not(.ellipsis) {
  width: fit-content;
}

:host([mask-type=button-mask]),
:host([mask-type=icon-mask]) {
  display: flex;
  align-items: center;
  gap: var(--ids-text-mask-btn-gap);
}
:host([mask-type=button-mask]) .mask-btn,
:host([mask-type=icon-mask]) .mask-btn {
  display: flex;
}

.ids-text {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-weight: var(--ids-font-weight-normal);
  display: block;
  margin: 0;
  color: currentColor;
  font-size: var(--ids-font-size-sm);
  text-decoration: unset;
}
.ids-text.audible {
  /* stylelint-disable-next-line property-no-deprecated */
  clip: rect(0, 0, 0, 0);
  color: var(--ids-color-text-default);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  position: none;
}
.ids-text.error {
  color: var(--ids-color-text-error);
}
.ids-text.label {
  color: var(--ids-color-text-label);
}
.ids-text.label.color-variant-alternate {
  color: var(--ids-color-text-inverse);
}
.ids-text.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ids-text.ellipsis div.has-tab-width {
  max-width: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ids-text.has-line-clamp {
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  /* stylelint-disable-next-line property-no-deprecated */
  word-wrap: break-word;
}
.ids-text.bold {
  font-weight: var(--ids-font-weight-bold);
}
.ids-text.semi-bold {
  font-weight: var(--ids-font-weight-semibold);
}
.ids-text.lighter {
  font-weight: var(--ids-font-weight-light);
}
.ids-text.text-align-start {
  text-align: start;
}
.ids-text.text-align-end {
  text-align: end;
}
.ids-text.text-align-center {
  text-align: center;
}
.ids-text.text-align-justify {
  text-align: justify;
}
.ids-text.status-gray::before, .ids-text.status-error::before, .ids-text.status-info::before, .ids-text.status-success::before, .ids-text.status-warning::before {
  display: inline-flex;
  margin-inline-end: var(--ids-input-margin-bottom);
  border-radius: var(--ids-border-radius-circle);
  content: "";
  height: 8px;
  width: 8px;
  position: relative;
  vertical-align: middle;
  top: -2px;
}
.ids-text.status-gray {
  color: var(--ids-color-text-label);
}
.ids-text.status-gray::before {
  background-color: var(--ids-color-text-label);
}
.ids-text.status-error {
  color: var(--ids-color-text-error);
}
.ids-text.status-error::before {
  background-color: var(--ids-color-text-error);
}
.ids-text.status-info {
  color: var(--ids-color-text-info);
}
.ids-text.status-info::before {
  background-color: var(--ids-color-text-info);
}
.ids-text.status-success {
  color: var(--ids-color-text-success);
}
.ids-text.status-success::before {
  background-color: var(--ids-color-text-success);
}
.ids-text.status-warning {
  color: var(--ids-color-text-warning);
}
.ids-text.status-warning::before {
  background-color: var(--ids-color-text-warning);
}
.ids-text.pre {
  white-space: pre;
}
.ids-text.pre-wrap {
  white-space: pre-wrap;
}
.ids-text.nowrap {
  white-space: nowrap;
}
.ids-text.pre-line {
  white-space: pre-line;
}
.ids-text.break-spaces {
  white-space: break-spaces;
}
.ids-text.normal {
  white-space: normal;
}
.ids-text.word-break-normal {
  word-break: normal;
}
.ids-text.word-break-break-all {
  word-break: break-all;
}
.ids-text.word-break-keep-all {
  word-break: keep-all;
}
.ids-text.word-break-break-word {
  overflow-wrap: anywhere;
}

:host(.inline) .ids-text {
  display: inline;
}

:host([word-wrap]) {
  white-space: normal;
  /* stylelint-disable-next-line property-no-deprecated */
  word-wrap: break-word;
}

.inline,
[display=inline] {
  display: inline;
}

.ids-text-color-unset {
  color: unset;
}

:host(.message-text) .ids-text {
  color: unset;
}
:host(.message-text) .ids-text.error {
  color: unset;
}

::slotted(.highlight) {
  font-weight: var(--ids-font-weight-bold);
}

::slotted(.audible) {
  /* stylelint-disable-next-line property-no-deprecated */
  clip: rect(0, 0, 0, 0);
  color: var(--ids-color-text-default);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

::slotted(.filter) {
  font-weight: var(--ids-font-weight-bold);
}

::slotted(ids-icon) {
  margin-inline-end: var(--ids-text-icon-margin);
  vertical-align: middle;
  position: relative;
  top: -2px;
}

:host([font-size="32"]) ::slotted(ids-icon),
:host([font-size="28"]) ::slotted(ids-icon),
:host([font-size="24"]) ::slotted(ids-icon),
:host([font-size="20"]) ::slotted(ids-icon) {
  margin-inline-end: var(--ids-text-icon-margin-lg);
}

::slotted(ids-alert) {
  margin: var(--ids-text-alert-margin);
  vertical-align: sub;
}

/* Ids Typography System */
.ids-text-10 {
  font-size: var(--ids-font-size-3xs);
  text-transform: uppercase;
}

.ids-text-12 {
  font-size: var(--ids-font-size-2xs);
  text-transform: uppercase;
}

.ids-text-14 {
  font-size: var(--ids-font-size-xs);
}

.ids-text-16 {
  font-size: var(--ids-font-size-sm);
}

.ids-text-20 {
  font-size: var(--ids-font-size-md);
}

.ids-text-24 {
  font-size: var(--ids-font-size-lg);
}

.ids-text-28 {
  font-size: var(--ids-font-size-xl);
}

.ids-text-32 {
  font-size: var(--ids-font-size-2xl);
}

.ids-text-40 {
  font-size: var(--ids-font-size-3xl);
}

.ids-text-48 {
  font-size: var(--ids-font-size-4xl);
}

.ids-text-60 {
  font-size: var(--ids-font-size-5xl);
}

.ids-text-72 {
  font-size: var(--ids-font-size-6xl);
  margin-block-end: 0;
}

.ids-text-color-muted.ids-text,
:host([disabled]) .ids-text {
  color: var(--ids-color-text-disabled);
}
.ids-text-color-muted.ids-text.label,
:host([disabled]) .ids-text.label {
  color: var(--ids-color-text-disabled);
}
.ids-text-color-muted.ids-text.color-variant-alternate.label,
:host([disabled]) .ids-text.color-variant-alternate.label {
  color: var(--ids-color-text-subtle);
}
.ids-text-color-muted.ids-text.status-base, .ids-text-color-muted.ids-text.status-error, .ids-text-color-muted.ids-text.status-info, .ids-text-color-muted.ids-text.status-success, .ids-text-color-muted.ids-text.status-warning,
:host([disabled]) .ids-text.status-base,
:host([disabled]) .ids-text.status-error,
:host([disabled]) .ids-text.status-info,
:host([disabled]) .ids-text.status-success,
:host([disabled]) .ids-text.status-warning {
  color: var(--ids-color-text-disabled);
}
.ids-text-color-muted.ids-text.status-error::before, .ids-text-color-muted.ids-text.status-info::before, .ids-text-color-muted.ids-text.status-success::before, .ids-text-color-muted.ids-text.status-warning::before,
:host([disabled]) .ids-text.status-error::before,
:host([disabled]) .ids-text.status-info::before,
:host([disabled]) .ids-text.status-success::before,
:host([disabled]) .ids-text.status-warning::before {
  background-color: var(--ids-color-text-disabled);
}

:host([class=label-checkbox]) .audible {
  position: relative;
  line-height: 1;
  height: unset;
}

::slotted(ids-badge) {
  position: relative;
  margin-inline-start: 8px;
  top: 1px;
  vertical-align: top;
}

:host([label-wrap=ellipsis]) .ids-text {
  display: block;
  width: 100%;
  max-inline-size: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host([label-wrap=ellipsis-no-stretch]) .ids-text {
  display: block;
  max-inline-size: 75%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host([label-wrap=wrap-no-stretch]) .ids-text {
  max-inline-size: 75%;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-text/ids-text.scss","webpack://./src/themes/mixins/ids-core-mixins.scss"],"names":[],"mappings":"AAAA,uBAAA;AAGA;EACE,wBAAA;AADF;;AAIA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;;EAEE,aAAA;EACA,mBAAA;EACA,iCAAA;AADF;AAGE;;EACE,aAAA;AAAJ;;AAIA;EClBE,mCAAA;EACA,kCAAA;EDoBA,+EAAA;EACA,0CAAA;EACA,cAAA;EACA,SAAA;EAIA,mBAAA;EAGA,kCAAA;EACA,sBAAA;AANF;AAQE;ECrBA,uDAAA;EACA,sBAAA;EACA,oCAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EDeE,cAAA;AAEJ;AACE;EACE,kCAAA;AACJ;AAEE;EACE,kCAAA;AAAJ;AAEI;EACE,oCAAA;AAAN;AAIE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;AAII;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAFN;AAME;EACE,oBAAA;EACA,aAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,uDAAA;EACA,qBAAA;AAJJ;AAOE;EACE,wCAAA;AALJ;AAQE;EACE,4CAAA;AANJ;AASE;EACE,yCAAA;AAPJ;AAWI;EACE,iBAAA;AATN;AAYI;EACE,eAAA;AAVN;AAaI;EACE,kBAAA;AAXN;AAcI;EACE,mBAAA;AAZN;AAgBE;EAKE,oBAAA;EACA,iDAAA;EACA,8CAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;AAlBJ;AAqBE;EACE,kCAAA;AAnBJ;AAqBI;EACE,6CAAA;AAnBN;AAuBE;EACE,kCAAA;AArBJ;AAuBI;EACE,6CAAA;AArBN;AAyBE;EACE,iCAAA;AAvBJ;AAyBI;EACE,4CAAA;AAvBN;AA2BE;EACE,oCAAA;AAzBJ;AA2BI;EACE,+CAAA;AAzBN;AA6BE;EACE,oCAAA;AA3BJ;AA6BI;EACE,+CAAA;AA3BN;AA+BE;EACE,gBAAA;AA7BJ;AAgCE;EACE,qBAAA;AA9BJ;AAiCE;EACE,mBAAA;AA/BJ;AAkCE;EACE,qBAAA;AAhCJ;AAmCE;EACE,yBAAA;AAjCJ;AAoCE;EACE,mBAAA;AAlCJ;AAqCE;EACE,kBAAA;AAnCJ;AAsCE;EACE,qBAAA;AApCJ;AAuCE;EACE,oBAAA;AArCJ;AAwCE;EACE,uBAAA;AAtCJ;;AA2CE;EACE,eAAA;AAxCJ;;AA4CA;EACE,mBAAA;EACA,uDAAA;EACA,qBAAA;AAzCF;;AA4CA;;EAEE,eAAA;AAzCF;;AA4CA;EACE,YAAA;AAzCF;;AA8CE;EACE,YAAA;AA3CJ;AA6CI;EACE,YAAA;AA3CN;;AAgDA;EACE,wCAAA;AA7CF;;AAgDA;EClOE,uDAAA;EACA,sBAAA;EACA,oCAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;ADsLF;;AAuCA;EACE,wCAAA;AApCF;;AAuCA;EACE,8CAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;AApCF;;AAuCA;;;;EAIE,iDAAA;AApCF;;AAuCA;EACE,oCAAA;EACA,mBAAA;AApCF;;AAuCA,0BAAA;AACA;EACE,mCAAA;EACA,yBAAA;AApCF;;AAuCA;EACE,mCAAA;EACA,yBAAA;AApCF;;AAuCA;EACE,kCAAA;AApCF;;AAuCA;EACE,kCAAA;AApCF;;AAuCA;EACE,kCAAA;AApCF;;AAuCA;EACE,kCAAA;AApCF;;AAuCA;EACE,kCAAA;AApCF;;AAuCA;EACE,mCAAA;AApCF;;AAuCA;EACE,mCAAA;AApCF;;AAuCA;EACE,mCAAA;AApCF;;AAuCA;EACE,mCAAA;AApCF;;AAuCA;EACE,mCAAA;EACA,mBAAA;AApCF;;AAwCA;;EAEE,qCAAA;AArCF;AAuCE;;EACE,qCAAA;AApCJ;AAuCE;;EACE,mCAAA;AApCJ;AAuCE;;;;;;EAKE,qCAAA;AApCJ;AAuCE;;;;;EAIE,gDAAA;AApCJ;;AAwCA;EACE,kBAAA;EACA,cAAA;EACA,aAAA;AArCF;;AAyCA;EACE,kBAAA;EACA,wBAAA;EACA,QAAA;EACA,mBAAA;AAtCF;;AA2CE;EACE,cAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAxCJ;;AA6CE;EACE,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA1CJ;;AA+CE;EACE,oBAAA;AA5CJ","sourcesContent":["/* Ids Text Component */\n@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n:host([hidden]) {\n  display: none !important;\n}\n\n:host([overflow='ellipsis']) {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n:host([tooltip]) .ids-text:not(.ellipsis) {\n  width: fit-content;\n}\n\n:host([mask-type=\"button-mask\"]),\n:host([mask-type=\"icon-mask\"]) {\n  display: flex;\n  align-items: center;\n  gap: var(--ids-text-mask-btn-gap);\n\n  .mask-btn {\n    display: flex;\n  }\n}\n\n.ids-text {\n  @include mixins.antialiased();\n\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  font-weight: var(--ids-font-weight-normal);\n  display: block;\n  margin: 0;\n\n  // Default color is inherited from IdsContainer,\n  // or from a wrapper element style\n  color: currentColor;\n\n  // Other defaults\n  font-size: var(--ids-font-size-sm);\n  text-decoration: unset;\n\n  &.audible {\n    @include mixins.audible();\n\n    position: none;\n  }\n\n  &.error {\n    color: var(--ids-color-text-error);\n  }\n\n  &.label {\n    color: var(--ids-color-text-label);\n\n    &.color-variant-alternate {\n      color: var(--ids-color-text-inverse);\n    }\n  }\n\n  &.ellipsis {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    div.has-tab-width {\n      max-width: inherit;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  &.has-line-clamp {\n    display: -webkit-box;\n    line-clamp: 2;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    white-space: normal;\n    /* stylelint-disable-next-line property-no-deprecated */\n    word-wrap: break-word;\n  }\n\n  &.bold {\n    font-weight: var(--ids-font-weight-bold);\n  }\n\n  &.semi-bold {\n    font-weight: var(--ids-font-weight-semibold);\n  }\n\n  &.lighter {\n    font-weight: var(--ids-font-weight-light);\n  }\n\n  &.text-align {\n    &-start {\n      text-align: start;\n    }\n\n    &-end {\n      text-align: end;\n    }\n\n    &-center {\n      text-align: center;\n    }\n\n    &-justify {\n      text-align: justify;\n    }\n  }\n\n  &.status-gray::before,\n  &.status-error::before,\n  &.status-info::before,\n  &.status-success::before,\n  &.status-warning::before {\n    display: inline-flex;\n    margin-inline-end: var(--ids-input-margin-bottom);\n    border-radius: var(--ids-border-radius-circle);\n    content: '';\n    height: 8px;\n    width: 8px;\n    position: relative;\n    vertical-align: middle;\n    top: -2px;\n  }\n\n  &.status-gray {\n    color: var(--ids-color-text-label);\n\n    &::before {\n      background-color: var(--ids-color-text-label);\n    }\n  }\n\n  &.status-error {\n    color: var(--ids-color-text-error);\n\n    &::before {\n      background-color: var(--ids-color-text-error);\n    }\n  }\n\n  &.status-info {\n    color: var(--ids-color-text-info);\n\n    &::before {\n      background-color: var(--ids-color-text-info);\n    }\n  }\n\n  &.status-success {\n    color: var(--ids-color-text-success);\n\n    &::before {\n      background-color: var((--ids-color-text-success));\n    }\n  }\n\n  &.status-warning {\n    color: var(--ids-color-text-warning);\n\n    &::before {\n      background-color: var(--ids-color-text-warning);\n    }\n  }\n\n  &.pre {\n    white-space: pre;\n  }\n\n  &.pre-wrap {\n    white-space: pre-wrap;\n  }\n\n  &.nowrap {\n    white-space: nowrap;\n  }\n\n  &.pre-line {\n    white-space: pre-line;\n  }\n\n  &.break-spaces {\n    white-space: break-spaces;\n  }\n\n  &.normal {\n    white-space: normal;\n  }\n\n  &.word-break-normal {\n    word-break: normal;\n  }\n\n  &.word-break-break-all {\n    word-break: break-all;\n  }\n\n  &.word-break-keep-all {\n    word-break: keep-all;\n  }\n\n  &.word-break-break-word {\n    overflow-wrap: anywhere;\n  }\n}\n\n:host(.inline) {\n  .ids-text {\n    display: inline;\n  }\n}\n\n:host([word-wrap]) {\n  white-space: normal;\n  /* stylelint-disable-next-line property-no-deprecated */\n  word-wrap: break-word;\n}\n\n.inline,\n[display='inline'] {\n  display: inline;\n}\n\n.ids-text-color-unset {\n  color: unset;\n}\n\n// Alert Colored Text\n:host(.message-text) {\n  .ids-text {\n    color: unset;\n\n    &.error {\n      color: unset;\n    }\n  }\n}\n\n::slotted(.highlight) {\n  font-weight: var(--ids-font-weight-bold);\n}\n\n::slotted(.audible) {\n  @include mixins.audible();\n}\n\n::slotted(.filter) {\n  font-weight: var(--ids-font-weight-bold);\n}\n\n::slotted(ids-icon) {\n  margin-inline-end: var(--ids-text-icon-margin);\n  vertical-align: middle;\n  position: relative;\n  top: -2px;\n}\n\n:host([font-size='32']) ::slotted(ids-icon),\n:host([font-size='28']) ::slotted(ids-icon),\n:host([font-size='24']) ::slotted(ids-icon),\n:host([font-size='20']) ::slotted(ids-icon) {\n  margin-inline-end: var(--ids-text-icon-margin-lg);\n}\n\n::slotted(ids-alert) {\n  margin: var(--ids-text-alert-margin);\n  vertical-align: sub;\n}\n\n/* Ids Typography System */\n.ids-text-10 {\n  font-size: var(--ids-font-size-3xs);\n  text-transform: uppercase;\n}\n\n.ids-text-12 {\n  font-size: var(--ids-font-size-2xs);\n  text-transform: uppercase;\n}\n\n.ids-text-14 {\n  font-size: var(--ids-font-size-xs);\n}\n\n.ids-text-16 {\n  font-size: var(--ids-font-size-sm);\n}\n\n.ids-text-20 {\n  font-size: var(--ids-font-size-md);\n}\n\n.ids-text-24 {\n  font-size: var(--ids-font-size-lg);\n}\n\n.ids-text-28 {\n  font-size: var(--ids-font-size-xl);\n}\n\n.ids-text-32 {\n  font-size: var(--ids-font-size-2xl);\n}\n\n.ids-text-40 {\n  font-size: var(--ids-font-size-3xl);\n}\n\n.ids-text-48 {\n  font-size: var(--ids-font-size-4xl);\n}\n\n.ids-text-60 {\n  font-size: var(--ids-font-size-5xl);\n}\n\n.ids-text-72 {\n  font-size: var(--ids-font-size-6xl);\n  margin-block-end: 0;\n}\n\n// Handle Disabled Text\n.ids-text-color-muted.ids-text,\n:host([disabled]) .ids-text {\n  color: var(--ids-color-text-disabled);\n\n  &.label {\n    color: var(--ids-color-text-disabled);\n  }\n\n  &.color-variant-alternate.label {\n    color: var(--ids-color-text-subtle);\n  }\n\n  &.status-base,\n  &.status-error,\n  &.status-info,\n  &.status-success,\n  &.status-warning {\n    color: var(--ids-color-text-disabled);\n  }\n\n  &.status-error::before,\n  &.status-info::before,\n  &.status-success::before,\n  &.status-warning::before {\n    background-color: var(--ids-color-text-disabled);\n  }\n}\n\n:host([class='label-checkbox']) .audible {\n  position: relative;\n  line-height: 1;\n  height: unset;\n}\n\n// Line badges up inline\n::slotted(ids-badge) {\n  position: relative;\n  margin-inline-start: 8px;\n  top: 1px;\n  vertical-align: top;\n}\n\n// Label wrap styles\n:host([label-wrap='ellipsis']) {\n  .ids-text {\n    display: block;\n    width: 100%;\n    max-inline-size: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n:host([label-wrap='ellipsis-no-stretch']) {\n  .ids-text {\n    display: block;\n    max-inline-size: 75%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n:host([label-wrap='wrap-no-stretch']) {\n  .ids-text {\n    max-inline-size: 75%;\n  }\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 2463px;\n$breakpoint-xl: 1183px;\n$breakpoint-lg: 928px;\n$breakpoint-md: 927px;\n$breakpoint-sm: 767px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  /* stylelint-disable-next-line property-no-deprecated */\n  clip: rect(0, 0, 0, 0);\n  color: var(--ids-color-text-default);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
